// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "bs-platform/lib/es6/list.js";
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as React from "react";
import * as Printf from "bs-platform/lib/es6/printf.js";
import * as $$String from "bs-platform/lib/es6/string.js";
import * as Color$YourProjectName from "../color.bs.js";

function edgeDirToString(edir) {
  if (edir) {
    return "reverse";
  } else {
    return "forward";
  }
}

function stringToEdgeDir(s) {
  if (s === "reverse") {
    return /* Reverse */1;
  } else {
    return /* Forward */0;
  }
}

function rotateEdge(edir, edge) {
  if (!edir) {
    return edge;
  }
  var match = edge.curve;
  if (match) {
    return {
            edge_id: edge.edge_id,
            scoord: edge.tcoord,
            tcoord: edge.scoord,
            curve: /* Bezier */{
              _0: match._1,
              _1: match._0
            },
            draw: edge.draw
          };
  } else {
    return {
            edge_id: edge.edge_id,
            scoord: edge.tcoord,
            tcoord: edge.scoord,
            curve: edge.curve,
            draw: edge.draw
          };
  }
}

function edgesToString(edges) {
  return $$String.concat(" ", List.map((function (param) {
                    var s = param[0];
                    if (param[1]) {
                      return "rev(" + (s + ")");
                    } else {
                      return s;
                    }
                  }), edges));
}

var name = "fill";

function render(fill) {
  var s = Curry._2(Printf.sprintf(/* Format */{
            _0: {
              TAG: /* Char_literal */12,
              _0: /* "(" */40,
              _1: {
                TAG: /* String */2,
                _0: /* No_padding */0,
                _1: {
                  TAG: /* String_literal */11,
                  _0: ") ",
                  _1: {
                    TAG: /* String */2,
                    _0: /* No_padding */0,
                    _1: /* End_of_format */0
                  }
                }
              }
            },
            _1: "(%s) %s"
          }), fill.fill_id, edgesToString(fill.edges));
  return React.createElement("div", {
              key: fill.fill_id
            }, s);
}

var Fill = {
  name: name,
  render: render
};

var initState = {
  name: "",
  color: /* Black */0,
  enames: /* [] */0,
  edir: /* Forward */0,
  ename: ""
};

function Fill$Add(Props) {
  var updater = Props.updater;
  var match = React.useState(function () {
        return initState;
      });
  var setState = match[1];
  var state = match[0];
  var enamesStr = edgesToString(List.rev(state.enames));
  var colorOnChange = function (e) {
    e.preventDefault();
    var c = Color$YourProjectName.fromString(e.target.value);
    return Curry._1(setState, (function (s) {
                  if (c !== undefined) {
                    return {
                            name: s.name,
                            color: c,
                            enames: s.enames,
                            edir: s.edir,
                            ename: s.ename
                          };
                  } else {
                    return s;
                  }
                }));
  };
  var handleName = function (e) {
    var a = e.target.value;
    return Curry._1(setState, (function (st) {
                  return {
                          name: a,
                          color: st.color,
                          enames: st.enames,
                          edir: st.edir,
                          ename: st.ename
                        };
                }));
  };
  var handleEname = function (e) {
    var a = e.target.value;
    return Curry._1(setState, (function (st) {
                  return {
                          name: st.name,
                          color: st.color,
                          enames: st.enames,
                          edir: st.edir,
                          ename: a
                        };
                }));
  };
  var edirOnChange = function (e) {
    e.preventDefault();
    var edStr = e.target.value;
    return Curry._1(setState, (function (s) {
                  return {
                          name: s.name,
                          color: s.color,
                          enames: s.enames,
                          edir: stringToEdgeDir(edStr),
                          ename: s.ename
                        };
                }));
  };
  var handleAppend = function (e) {
    e.preventDefault();
    return Curry._1(setState, (function (param) {
                  return {
                          name: state.name,
                          color: state.color,
                          enames: {
                            hd: [
                              state.ename,
                              state.edir
                            ],
                            tl: state.enames
                          },
                          edir: state.edir,
                          ename: ""
                        };
                }));
  };
  var handleSubmit = function (e) {
    e.preventDefault();
    Curry._3(updater, state.name, state.color, List.rev(state.enames));
    return Curry._1(setState, (function (param) {
                  return initState;
                }));
  };
  return React.createElement("div", {
              className: "add fill"
            }, React.createElement("form", {
                  onSubmit: handleSubmit
                }, "Fill: ", "name=", React.createElement("input", {
                      className: "input-name",
                      name: "name",
                      type: "text",
                      value: state.name,
                      onChange: handleName
                    }), Color$YourProjectName.select(state.color, colorOnChange), React.createElement("input", {
                      className: "input-name",
                      name: "ename",
                      type: "text",
                      value: state.ename,
                      onChange: handleEname
                    }), React.createElement("select", {
                      value: state.edir ? "reverse" : "forward",
                      onChange: edirOnChange
                    }, React.createElement("option", {
                          value: "forward"
                        }, "forward"), React.createElement("option", {
                          value: "reverse"
                        }, "reverse")), React.createElement("button", {
                      onClick: handleAppend
                    }, "append"), React.createElement("input", {
                      type: "submit",
                      value: "add/modify",
                      onClick: (function (param) {
                          
                        })
                    }), enamesStr));
}

var Add = {
  initState: initState,
  make: Fill$Add
};

export {
  edgeDirToString ,
  stringToEdgeDir ,
  rotateEdge ,
  edgesToString ,
  Fill ,
  name ,
  render ,
  Add ,
  
}
/* react Not a pure module */
